import { render, staticRenderFns } from "./YoutubeVideoEditLanding.vue?vue&type=template&id=24b97ab8"
import script from "./YoutubeVideoEditLanding.vue?vue&type=script&lang=js"
export * from "./YoutubeVideoEditLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports